import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { WhyItFailedSection } from './components/WhyItFailedSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { WhoIsItForSection } from './components/WhoIsItForSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { FinalOfferSection } from './components/FinalOfferSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-gray-900 selection:bg-gold selection:text-forest" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <WhyItFailedSection data-id="element-3" />
      <MechanismSection data-id="element-4" />
      <WhatYouGetSection data-id="element-5" />
      <WhoIsItForSection data-id="element-6" />
      <HowItWorksSection data-id="element-7" />
      <ProofSection data-id="element-8" />
      <FAQSection data-id="element-9" />
      <FinalOfferSection data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}